
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ruqia",
      function () {
        return require("private-next-pages/ruqia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ruqia"])
      });
    }
  